import { Map } from 'immutable';

import { convertActionToPreviousStructure } from 'app/api';
import { NAMESPACE_INTERESTING_MATCHES } from 'app/constants/Context';
import { NOTIFY_ABOUT_CHANGED_LANG } from 'app/lang';
import { SlotType } from 'app/lib/betting/betting-entities';
import {
  SET_INTERESTING_MATCHES_GRID_STAKE_TYPES,
  SET_INTERESTING_MATCHES_ORDER_KEY,
} from 'app/redux/betting-presentation/grid/actions';
import { TRANSFORM_SSR_STATE } from 'app/redux/ssrState';

import {
  APPLY_INTERESTING_MATCHES_STATE,
  fetchInterestingMatches,
  SHOW_LIVE_MATCHES,
  SUBSCRIBE,
  UNSUBSCRIBE,
} from '../actions';
import reduceEntities from './entities';
import reducePresentation from './grid';

// ---

const initialState = Map({
  entities: reduceEntities(undefined, '@@init'),
  grid: reducePresentation(undefined, NAMESPACE_INTERESTING_MATCHES, '@@init', undefined),
  showLiveMatches: false,
  hasLiveMatches: false,
});

const updateInterestingMatches = (state, action) => {
  const convertedAction = convertActionToPreviousStructure(action);

  state = state.update('entities', (entities) => reduceEntities(entities, convertedAction));
  state = state.update('grid', (grid) => reducePresentation(grid, NAMESPACE_INTERESTING_MATCHES, convertedAction, state.get('entities')));
  return state;
};

const updateHasLiveMatches = (state) => {
  const matches = state?.get('entities')?.get('matches')?.get('byId');
  if (!matches) {
    return state;
  }
  const hasLiveMatches = matches.some((match) => {
    return match.slotType === SlotType.LIVE;
  });
  state = state.set('hasLiveMatches', hasLiveMatches);

  return state;
};

export default function (state = initialState, action) {
  switch (action.type) {
    case fetchInterestingMatches.pending.toString():
    case fetchInterestingMatches.rejected.toString():
    case UNSUBSCRIBE:
    case SET_INTERESTING_MATCHES_GRID_STAKE_TYPES:
    case SET_INTERESTING_MATCHES_ORDER_KEY:
    case NOTIFY_ABOUT_CHANGED_LANG:
      return updateInterestingMatches(state, action);

    case SUBSCRIBE:
    case APPLY_INTERESTING_MATCHES_STATE:
    case fetchInterestingMatches.fulfilled.toString():
      state = updateInterestingMatches(state, action);
      state = updateHasLiveMatches(state);
      return state;

    case TRANSFORM_SSR_STATE: {
      if (Map.isMap(state)) {
        return state; // already transformed (initial state case)
      }

      const entities = reduceEntities(state.entities, action);

      return Map({
        entities,
        grid: reducePresentation(state.grid, NAMESPACE_INTERESTING_MATCHES, action, entities),
        hasLiveMatches: state.hasLiveMatches,
      });
    }

    case SHOW_LIVE_MATCHES:
      return state.update('showLiveMatches', (showLiveMatches) => !showLiveMatches);

    default:
      return state;
  }
}
